import { render, staticRenderFns } from "./SupWhiteBlack.vue?vue&type=template&id=6844c059&"
import script from "./SupWhiteBlack.vue?vue&type=script&lang=js&"
export * from "./SupWhiteBlack.vue?vue&type=script&lang=js&"
import style0 from "./SupWhiteBlack.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports